/* eslint-disable function-paren-newline */
/* eslint-disable indent */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable arrow-parens */
/* eslint-disable operator-linebreak */
import './style.scss'
import common from '@/utils/common'
import { renderToString } from 'react-dom/server'
import { SummaryLine, EarlyBird, DiscountBox } from '@/style-guide'
import { getCosting } from '@/utils/InvoiceHelper'
import moment from 'moment'
import { TripPicture } from '../TripPicture'
import { Button, Divider, Modal, Typography } from 'antd'
import { HostInfo, OrganizationInfo } from '../AttendeeInfo'
import { useEffect } from 'react'
import TextArea from 'antd/lib/input/TextArea'
import { DiscountCodeInput } from '../CoreComponents'
const { Text } = Typography
const Summary = ({
  trip,
  preferences,
  showTop = true,
  showBottom = true,
  hideImage = false,
  attendeesCount,
  guests,
  setPreferences
}) => {
  // Trip dates
  const start = trip.startDate ? common.dateFormat(trip.startDate) : ''
  const endDate = trip.startDate
    ? common.getEndDate(trip.startDate, trip.tripLength)
    : ''
  const end = endDate ? common.dateFormat(endDate.format('YYYYMMDD')) : ''
  const dates = `${start} - ${end}`
  const duration = trip.tripLength
  const getDiscount = (amount, disc) => {
    if (disc.discType == 'percentage') {
      return (amount * disc.amount) / 100
    } else return disc.amount
  }

  const [startDateEventDates, endDateEventDates] = dates.split(' - ');
  const startEventDates = moment(startDateEventDates, 'MMMM DD, YYYY');
  const endEventDates = moment(endDateEventDates, 'MMMM DD, YYYY');
  const formattedEventDates = `${startEventDates.format('MMM D')} - ${endEventDates.format('D')}`;

  const {
    paynowAmount,
    discountedGrandTotal,
    discountTotal,
    grandTotal,
    totalRoomCost,
    totalAddOnCost,
    platformFee,
    cardFee,
    ethMainnetFee,
    serviceFee,
    futureCardFee,
    futurePlatformFee,
    futureEthMainnetFee,
    futureServiceFee,
    payFutureAmount,
  } = getCosting(preferences, trip)
  let earlyBirdDiscount = 0
  if (trip.discounts?.length > 0) {
    trip.discounts?.forEach((d) => {
      earlyBirdDiscount += getDiscount(grandTotal, d)
    })
  }

  // Trip summary
  const renderTripSummary = () => {

    const groupedRooms = preferences?.rooms?.reduce((acc, room) => {
      if (!acc[room.room.id]) {
        acc[room.room.id] = [];
      }
      acc[room.room.id].push(room);
      return acc;
    }, {}) || {};

    const groupedAddOns = preferences?.addOns?.reduce((acc, addOn) => {
      if (!acc[addOn.addOn.id]) {
        acc[addOn.addOn.id] = [];
      }
      acc[addOn.addOn.id].push(addOn);
      return acc;
    }, {}) || {};

    if (
      //grandTotal > 0 &&
      (preferences?.rooms?.length > 0 || preferences?.addOns?.length > 0)
    ) {
      return (
        <>
          <Divider />
          {preferences?.rooms?.length > 0 && (
            <div style={{ marginTop: '5px' }}>
              {Object.keys(groupedRooms)?.map((roomId) => (
                <div className='booking-options-card' key={'summary_' + roomId}>
                  <SummaryLine key={'summaryGroup_' + roomId}>
                    <Text className='room-group' type="secondary">
                      {(groupedRooms[roomId][0].room.name).toUpperCase()}
                    </Text>
                  </SummaryLine>
                  <div className='hr-payment-summary'></div>
                  {groupedRooms[roomId]?.map((room, index) => (
                    <SummaryLine key={'summary_' + roomId + "_variant_" + room.variant.id}>
                      <Text>
                        <div className='variant-name'>
                          {room.variant.name}
                          {' x '}
                          {room.attendees}
                        </div>
                      </Text>
                      <Text>
                        <div className='variant-cost'>
                          {common.toCurrency(room.variant.cost * room.attendees)}
                        </div>
                      </Text>
                    </SummaryLine>
                  ))}
                </div>
              ))}
            </div>
          )}
          {preferences?.rooms?.length > 0 && (
            <div style={{ marginTop: '5px' }}>
              {Object.keys(groupedAddOns)?.map((addOnId) => (
                <div className='add-ons-card' key={`summary_div_${addOnId}`}>
                  <SummaryLine key={`summaryGroup_${addOnId}`}>
                    <Text type="secondary">
                      {(groupedAddOns[addOnId][0].addOn.name).toUpperCase()}
                    </Text>
                  </SummaryLine>
                  <div className='hr-payment-summary'></div>
                  {groupedAddOns[addOnId]?.map((addOn) => (
                    <SummaryLine key={`summary_${addOn.addOn.id}_variant_${addOn.variant.id}`}>
                      <Text>
                        <div className='variant-name'>
                          {addOn.variant.name}
                          {' x '}
                          {addOn.attendees}
                        </div>
                      </Text>
                      <Text>
                        <div className='variant-cost'>
                          {common.toCurrency(addOn.variant.cost * addOn.attendees)}
                        </div>
                      </Text>
                    </SummaryLine>
                  ))}
                </div>
              ))}
            </div>
          )}
        </>
      )
    }
    return null
  }
  const getPaymentTerms = () => {
    if (preferences.payment === 'deposit') {
      if (
        trip?.isDepositApplicable &&
        trip?.deposit &&
        trip?.deposit.includeAddOns
      ) {
        return ` Deposit x ${preferences.attendees} + add-ons`
      }
      return ` Deposit x ${preferences.attendees}`
    }
    return ' Full payment'
  }
  const paymentTerms = getPaymentTerms()
  const renderDueNow = () => (
    <>
      <Divider />
      {/* <SummaryLine>
        <Text>What you&#8217;ll pay now</Text>
        <Text>$0.00</Text>
      </SummaryLine> */}
      <div className='hr-payment'></div>
      <SummaryLine className="margin-top-10">
        <Text style={{ flex: 1 }}>
          <b>
            Total price |<Text>{paymentTerms}</Text>
          </b>
        </Text>
        <Text>
          <b>{common.toCurrency(paynowAmount + serviceFee)}</b>
        </Text>
      </SummaryLine>
    </>
  )
  const getFuturePayDate = () => {
    if (trip.lastBookingDate) {
      let lastBookingDate = moment(trip.lastBookingDate, 'YYYYMMDD').endOf(
        'day',
      )
      if (lastBookingDate.diff(moment(), 'days') > 30)
        lastBookingDate = moment().add(30, 'days')
      return `(${lastBookingDate.format('MMM DD, YYYY')})`
    } else return ''
  }
  const renderDueFuture = () => (
    <>
      <Divider />
      <SummaryLine>
        <Text>
          What you&#8217;ll pay in future <Text>{getFuturePayDate()}</Text>
        </Text>
        <Text>{common.toCurrency(payFutureAmount + futureServiceFee)}</Text>
      </SummaryLine>
      {/* <SummaryLine>
        <Text>
          (Includes {futurePlatformFee > 0 ? 'Platform service fee' : ''}{' '}
          {futurePlatformFee > 0 ? 'and Payment processing fee' : ''}{' '}
          {common.toCurrency(futureServiceFee)})
        </Text>
        <Text></Text>
      </SummaryLine> */}
    </>
  )

  //const showImage = showTop && !hideImage

  const showBottomFunc = () => {
    // if (
    //   attendeesCount === 1 &&
    //   preferences?.rooms?.[0] &&
    //   (!preferences.rooms[0].variant?.optionVariants ||
    //     preferences.rooms[0].variant.optionVariants.length === 0 ||
    //     preferences.selectedOptionVariants?.length === 1)
    // ) {
    //   return true;
    // }

    // if (attendeesCount === 2 && preferences.rooms && preferences.rooms.length) {
    //   const count = preferences.rooms.filter(obj => 'optionVariants' in obj.variant).length;
    //   if (preferences.selectedOptionVariants && preferences.selectedOptionVariants.length === 2 && count === 2) {
    //     return true;
    //   }
    //   if (preferences.selectedOptionVariants && preferences.selectedOptionVariants.length === 2) {
    //     return true;
    //   }

    //   let countOptionVariants = 0;
    //   preferences.rooms.forEach(room => {
    //     if ("optionVariants" in room.variant && room.variant.optionVariants.length === 0 || !("optionVariants" in room.variant)) {
    //       countOptionVariants = countOptionVariants + 1;
    //     }
    //   })

    //   if (countOptionVariants === 2) {
    //     return true;
    //   }

    //   if (countOptionVariants === 1 && preferences.rooms && preferences.rooms[0].attendees === 2) {
    //     return true;
    //   }

    //   if (countOptionVariants === 1 && preferences.selectedOptionVariants && preferences.selectedOptionVariants.length === 1) {
    //     return true;
    //   }
    // }

    //return false;
    return true;
  }

  const showAdditionalInformation = () => {
    return <div className='additional-information'>
      <div className='discount'>
        <DiscountCodeInput preferences={preferences} setPreferences={setPreferences} tripId={trip?._id} />
      </div>
    </div>
  }

  const showPaymentDetails = () => {
    const rooms = {}
    if (preferences?.rooms?.length > 0) {
      preferences.rooms?.forEach((room) => {
        if (!rooms.hasOwnProperty(room.room.id))
          rooms[room.room.id] = {
            room: room.room,
            attendees: room.attendees,
            variants: [],
          }
        rooms[room.room.id]?.variants.push(room.variant)
      })
    }
    const addOns = {}
    if (preferences?.addOns?.length > 0) {
      preferences.addOns?.forEach((addOn) => {
        if (!addOns.hasOwnProperty(addOn.addOn.id))
          addOns[addOn.addOn.id] = {
            addOn: addOn.addOn,
            attendees: addOn.attendees,
            variants: [],
          }
        addOns[addOn.addOn.id]?.variants.push(addOn.variant)
      })
    }
    if (
      grandTotal > 0 &&
      (preferences.rooms?.length > 0 || preferences.addOns?.length > 0)
    ) {
      return <><SummaryLine className={"total"} style={{ marginTop: '10px' }}>
        <Text>
          <b>Subtotal</b>
        </Text>
        <Text>
          <b>{common.toCurrency(grandTotal)}</b>
        </Text>
      </SummaryLine>

        {
          discountTotal > 0 && (
            <>

              <SummaryLine style={{ marginTop: '10px' }}>
                <Text>Discount</Text>
              </SummaryLine>
              {preferences.discounts && preferences.discounts?.length > 0 && (
                <>
                  {preferences.discounts?.map((d) => (
                    <SummaryLine style={{ marginTop: '10px' }}>
                      <EarlyBird>
                        <DiscountBox>{d.couponCode}</DiscountBox>
                      </EarlyBird>
                      <Text>
                        - {d.discType === 'amount' && '$'}
                        {d.amount}
                        {d.discType === 'percentage' && '%'}{' '}
                      </Text>
                    </SummaryLine>
                  ))}
                </>
              )}

              {preferences.coupon && (
                <SummaryLine style={{ marginTop: '10px' }}>
                  <EarlyBird>
                    <DiscountBox>{preferences.coupon?.couponCode}</DiscountBox>
                  </EarlyBird>
                  <Text>
                    - {preferences.coupon?.discType === 'amount' && '$'}
                    {preferences.coupon?.amount}
                    {preferences.coupon?.discType === 'percentage' && '%'}{' '}
                  </Text>
                </SummaryLine>
              )}
              {discountTotal > 0 && (
                <SummaryLine
                  style={{
                    marginTop: '10px',
                  }}
                >
                  <div></div>
                  <Text style={{ borderTop: '1px solid' }}>
                    -{common.toCurrency(discountTotal)}
                  </Text>
                </SummaryLine>
              )}
            </>
          )
        }
        {
          platformFee > 0 && (
            <SummaryLine style={{ marginTop: '10px' }}>
              <Text>Tax</Text>
              <Text>
                {common.toCurrency(platformFee + futurePlatformFee)}
              </Text>
            </SummaryLine>
          )
        }
        {/* {cardFee > 0 && (
    <SummaryLine style={{ marginTop: '10px' }}>
      <Text>Payment processing charge</Text>
      <Text>+ {common.toCurrency(cardFee + futureCardFee)}</Text>
    </SummaryLine>
  )}
  {ethMainnetFee > 0 && (
    <SummaryLine style={{ marginTop: '10px' }}>
      <Text>ETH Mainnet charge</Text>
      <Text>
        + {common.toCurrency(ethMainnetFee + futureEthMainnetFee)}
      </Text>
    </SummaryLine>
  )} */}
        {/* {discountedGrandTotal > 0 ? (
    <SummaryLine style={{ marginTop: '20px' }}>
      <Text>
        <b>Booking total</b>
      </Text>
      <Text>
        <b>
          {common.toCurrency(
            discountedGrandTotal + serviceFee + futureServiceFee,
          )}
        </b>
      </Text>
    </SummaryLine>
  ) : (
    'No payment required'
  )} */}
      </>
    }
  }

  return (
    <div className="summary">
      {/* {showImage ? <TripPicture trip={trip} height={300} /> : null} */}
      <div style={{ width: '100%' }}>
        {showTop && (
          <div className="top-section">
            <div>
              <div><Typography.Title level={4}>{"Cart Summary"}</Typography.Title></div>
              <div className='hr-payment'></div>
            </div>
            <div className='summary-info'>
              <div className='summary-guests'>
                <div>Guests</div>
                <div>{guests} guests</div>
              </div>
              <div className='dates-info'>
                <div>Event Dates</div>
                <div>{formattedEventDates}</div>
              </div>
            </div>
            {preferences?.attendees === 2 && <div className='guest-details-summary'>
              <div className='guest-details-summary-title'>GUEST INFORMATION</div>
              <div className='hr-payment-summary'></div>
              <div className='guest-details-summary-flex'>
                <div>Name: </div>
                <div>{preferences?.guests[0]?.name ? preferences?.guests[0]?.name : "-"}</div>
              </div>
              <div className='guest-details-summary-flex'>
                <div>Email: </div>
                <div>{preferences?.guests[0]?.email ? preferences?.guests[0]?.email : "-"}</div>
              </div>
              <div className='guest-details-summary-flex'>
                <div>Relationship: </div>
                <div>{preferences?.guests[0]?.relationship ? preferences?.guests[0]?.relationship : "-"}</div>
              </div>
              <div className='guest-details-summary-flex'>
                <div>Tripsha username: </div>
                <div>{preferences?.guests[0]?.username ? preferences?.guests[0]?.username : "-"}</div>
              </div>
            </div>}
          </div>
        )}

        {showBottom && (
          <div className="bottom-section">
            {showBottomFunc() && renderTripSummary()}
            {showAdditionalInformation()}
            {showBottomFunc() && showPaymentDetails()}
            {showBottomFunc() && discountedGrandTotal > 0 && renderDueNow()}
            {showBottomFunc() && discountedGrandTotal > paynowAmount && renderDueFuture()}
            {preferences.payment && <Divider />}
            {preferences.payment && (
              <Button
                type="link"
                onClick={() =>
                  Modal.info({
                    className: 'infomodel',
                    title: (
                      <Typography.Title level={4}>
                        How do booking requests work?
                      </Typography.Title>
                    ),
                    icon: '',
                    width: 600,
                    content: (
                      <div>
                        <div>
                          <Typography.Title level={5}>Timing</Typography.Title>
                        </div>
                        <div style={{ marginTop: '5px' }}>
                          <Typography.Text>
                            This booking request will remain open for{' '}
                            <b>
                              {renderToString(trip.bookingExpiryDays || 3)} days
                            </b>
                            . If the host does not accept or decline your
                            request within that timeframe, your request will
                            expire. After the expiration, you will not be
                            charged for the same request. However, if you wish
                            to proceed, you can submit a new booking request.
                          </Typography.Text>
                        </div>
                        <div className="margin-top-10">
                          <Typography.Title level={5}>
                            Acceptance
                          </Typography.Title>
                        </div>
                        <div style={{ marginTop: '5px' }}>
                          <Typography.Text>
                            If your booking request is approved, the agreed
                            amount will be charged to your chosen payment
                            method.
                            <p style={{ marginTop: '5px' }}>
                              In case you have made a booking with deposit, the
                              remaining balance will be charged to your payment
                              method 30 days before the event start date.
                            </p>
                          </Typography.Text>
                        </div>
                        <div className="margin-top-10">
                          <Typography.Title level={5}>
                            How to withdraw a booking request?
                          </Typography.Title>
                        </div>
                        <div style={{ marginTop: '5px' }}>
                          <Typography.Text>
                            You have the option to withdraw your booking request
                            at any time while it remains open by accessing your{' '}
                            <b>All Events</b> page. By doing so, the host will no
                            longer be able to accept your booking, and you will
                            not be charged.
                          </Typography.Text>
                        </div>
                      </div>
                    ),
                  })
                }
              >
                How do booking requests work?
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default Summary
